import { TeleservicesStatut, TeleservicesTypesEnum } from '../../types';
export const teleserviceMocked = {
    href: '/referentiel-financement/api/tenants/faketenant/teleservices/TELE_TEST?date=2022-11-17T14:49:57.978Z',
    reference: 'TELE_TEST',
    title: 'Téléservice type de TEST',
    validationEntreeFormation: false,
};
export const teleserviceContributionInformation = {
    id: '/referentiel-financement/api/tenants/test/teleservices/TS1',
    reference: 'TS1',
    title: 'Téléservice 1',
    statut: TeleservicesStatut.PUBLIE,
    workflow: {
        type: TeleservicesTypesEnum.CONTRIBUTION_INFORMATION,
        contributionInformation: {
            display: {
                allowDemandeurs: true,
                allowIntervenants: true,
                conditionMasquage: '',
            },
            pagePreambule: { actif: true },
            pagePieces: { actif: true },
            pageRecapitulatif: { actif: true },
            pageConfirmation: { actif: true },
            pageContributionInformation: {
                actif: true,
                typesInformation: [],
                date: { required: true, hidden: false },
                type: { required: true, hidden: false },
                motif: { required: true, hidden: false },
                commentaire: { required: true, hidden: false },
            },
        },
    },
};
//# sourceMappingURL=teleservice.js.map